import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from './shared/config/language';
import siteSettings from './shared/config/site-settings';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styles: ['']
})
export class AppComponent implements OnInit {

  constructor(private translate: TranslateService) {
    translate.setDefaultLang('kk');
  }

  ngOnInit(): void {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');
    const accessToken = urlParams.get('access_token');

    // Handle access token if present
    if (accessToken) {
      localStorage.setItem('access_token', accessToken);
    }

    // Determine language priority:
    // 1. URL parameter
    // 2. Local storage
    // 3. Default (kk)
    let lang = 'kk';
    let language: number = Language.KAZ;

    if (urlLang) {
      // URL parameter takes precedence
      lang = urlLang;
      switch (urlLang) {
        case 'ru':
          language = Language.RUS;
          break;
        case 'en':
          language = Language.ENG;
          break;
        default:
          language = Language.KAZ;
      }
    } else {
      // Fall back to localStorage
      const storedLanguage = JSON.parse(localStorage.getItem('eJambylLanguage') ?? '');
      if (storedLanguage) {
        if (storedLanguage === Language.RUS) {
          lang = 'ru';
          language = Language.RUS;
        } else if (storedLanguage === Language.ENG) {
          lang = 'en';
          language = Language.ENG;
        }
      }
    }

    // Set the language
    this.translate.use(lang);
    localStorage.setItem('eJambylLanguage', JSON.stringify(language));
    siteSettings.language = language;

    // Update URL without page reload if language was changed
    if (urlLang && urlLang !== lang) {
      const url = new URL(window.location.href);
      url.searchParams.set('lang', lang);
      window.history.pushState({}, '', url.toString());
    }
  }
}
